var lastScroll = 0;
window.addEventListener('scroll',(e) => {
  let scrollCount = window.pageYOffset;
  setTimeout(function(){
    if(scrollCount > lastScroll){
      document.body.classList.remove('scroll-up');
      document.body.classList.add('scroll-down');
    }else if(scrollCount < lastScroll){
      document.body.classList.remove('scroll-down');
      document.body.classList.add('scroll-up');
    }
    if(scrollCount > 0){
      document.body.classList.add('scroll-start');
    }else{
      document.body.classList.remove('scroll-start');
    }
    lastScroll = scrollCount;
  }, 0);
})


document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth > 991) {
    const body = document.body;
    const searchDrawer = document.querySelector(".search-drawer-outer");
    const closeBtn = document.querySelector(".close_search");
    const searchButtons = document.querySelectorAll(".mobile-search");
    const bottomEl = document.querySelector(".search-drawer-outer .bottom");
    let swiperInstance;

    searchButtons.forEach(function (searchButton) {
      searchButton.addEventListener("click", function () {
        body.classList.add("open-search");
        lenis.stop();
        searchDrawer.style.maxHeight = window.innerHeight + "px";

        searchDrawer.addEventListener(
          "transitionend",
          function handler(e) {
            if (e.propertyName === "max-height") {
              if (bottomEl) bottomEl.style.display = "flex";
              document.querySelectorAll("#Search").forEach((input) => input.focus());
              // initSearchRowSwipers();

              searchDrawer.removeEventListener("transitionend", handler);
            }
          }
        );
      });
    });


    closeBtn?.addEventListener("click", function () {

      body.classList.remove("open-search");
      lenis.start();

      if (bottomEl) bottomEl.style.display = "none";
      searchDrawer.style.maxHeight = "0px";

      document.querySelectorAll(".close_search, .snippet-search-bar").forEach(el => {
        el.classList.add("hidden");
      });

      searchDrawer.addEventListener(
        "transitionend",
        function handler() {
          // body.classList.remove("open-search");
          lenis.start();
          searchDrawer.style.maxHeight = "";

          document.querySelectorAll(".close_search, .snippet-search-bar").forEach(el => {
            el.classList.remove("hidden");
          });

          searchDrawer.removeEventListener("transitionend", handler);
        }
      );
    });


    window.addEventListener("resize", function () {
      if (body.classList.contains("open-search")) {
        searchDrawer.style.maxHeight = window.innerHeight + "px";
      }
    });
  }else{
    const closeBtn = document.querySelector(".close_search");
    closeBtn?.addEventListener("click", function () {
      document.body.classList.remove("open-search");
      lenis.start();
    });
  }
});


// function initSearchRowSwipers() {
//   document.querySelectorAll(".search-row").forEach((searchRow) => {
//     if (searchRow.classList.contains("swiper-initialized")) return;

//     const swiper = new Swiper(searchRow, {
//       slidesPerView: 2.1,
//       spaceBetween: 1,
//       loop: false,
//       freeMode: true,
//       watchOverflow: false, // keep Swiper always initialized
//       breakpoints: {
//         992: {
//           slidesPerView: 4,
//           spaceBetween: 1,
//           freeMode: false,
//           loop: false
//         },
//       },
//       on: {
//         init: function () {
//           const checkSlides = () => {
//             const totalSlides = this.slides.length;
//             const currentSlidesPerView =
//               this.params.slidesPerView === "auto"
//                 ? 1
//                 : Math.floor(this.params.slidesPerView) || 1;

//             // disable only if total slides are LESS than per view
//             if (totalSlides < currentSlidesPerView) {
//               this.disable();
//               this.el.classList.add("swiper-no-swiping");
//             } else {
//               this.enable();
//               this.el.classList.remove("swiper-no-swiping");
//             }
//           };

//           this.setBreakpoint(); // force breakpoint params
//           this.update();
//           checkSlides();
//         },
//         resize: function () {
//           const totalSlides = this.slides.length;
//           const currentSlidesPerView =
//             this.params.slidesPerView === "auto"
//               ? 1
//               : Math.floor(this.params.slidesPerView) || 1;

//           if (totalSlides < currentSlidesPerView) {
//             this.disable();
//             this.el.classList.add("swiper-no-swiping");
//           } else {
//             this.enable();
//             this.el.classList.remove("swiper-no-swiping");
//           }
//         }
//       }
//     });
//   });
// }



// document.addEventListener("DOMContentLoaded", initSearchRowSwipers);

document.addEventListener('DOMContentLoaded', function() {
  const searchInput = document.getElementById('Search');
  const clearBtn = document.querySelector('.clr-input');

  const toggleClear = () => {
    clearBtn.style.display = searchInput.value.trim() ? 'inline-block' : 'none';
  };

  toggleClear();

  searchInput.addEventListener('input', toggleClear);

  clearBtn.addEventListener('click', () => {
    searchInput.value = '';
    toggleClear();
    searchInput.focus();
  });
});


// document.addEventListener("click", function (event) {

//   if (event.target.closest(".quick-add-to-cart")) {
//     const addToCartBtn = event.target.closest(".quick-add-to-cart");
//     const line = addToCartBtn.getAttribute("data-id");
//     if (!line) return;

//     const data = {
//       items: [
//         {
//           id: line,
//           quantity: 1,
//         },
//       ],
//     };

//     fetch("/cart/add.js", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(data),
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         document.body.classList.remove("open-search");
//         document.body.classList.add("open-drawer");
//         load_cart();
//       })
//       .catch((error) => {
//         console.error("Error:", error);
//       });
//   }
// });




// document.addEventListener("click", function (event) {
//   if (event.target.closest(".search-drawer-wrapper .quick-add-to-cart")) {
//     const addToCartBtn = event.target.closest(".search-drawer-wrapper .quick-add-to-cart");
//     const line = addToCartBtn.getAttribute("data-id");
//     if (!line) return;

//     const title = addToCartBtn.getAttribute("data-pro-title") || "";
//     const imgSrc = addToCartBtn.getAttribute("data-img-src") || "";

//     // Popup elements
//     const cartPopup = document.getElementById("cart-popup");
//     const popupTitle = document.getElementById("cart-popup-title");
//     const popupImage = document.getElementById("cart-popup-image");
//     const popupClose = document.querySelector(".cart-popup-close");

//     let popupTimer;

//     const data = {
//       items: [
//         {
//           id: line,
//           quantity: 1,
//         },
//       ],
//     };

//     fetch("/cart/add.js", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(data),
//     })
//       .then((response) => response.json())
//       .then(() => {
//         // Drawer logic
//         // document.body.classList.remove("open-search");
//         // document.body.classList.add("open-drawer");
//         if (typeof load_cart === "function") load_cart();

//         // --- Cart Notification ---
//         if (cartPopup && popupTitle && popupImage) {
//           popupTitle.textContent = title;
//           popupImage.src = imgSrc;

//           // Show popup
//           cartPopup.classList.remove("hidden");
//           cartPopup.classList.add("visible");

//           clearTimeout(popupTimer);

//           // Hide after 3s
//           popupTimer = setTimeout(() => {
//             cartPopup.classList.remove("visible");
//             setTimeout(() => cartPopup.classList.add("hidden"), 300);
//           }, 3000);
//         }
//       })
//       .catch((error) => console.error("Error:", error));

//     // Manual close (attach once)
//     if (popupClose && !popupClose.hasListener) {
//       popupClose.addEventListener("click", function () {
//         clearTimeout(popupTimer);
//         cartPopup.classList.remove("visible");
//         setTimeout(() => cartPopup.classList.add("hidden"), 300);
//       });
//       popupClose.hasListener = true;
//     }
//   }
// });



const searchdrawer = document.querySelector('.search-bar-wrapper');

searchdrawer.addEventListener('wheel', (e) => {
  e.stopPropagation();
}, { passive: false });

searchdrawer.addEventListener('touchstart', (e) => {
  e.stopPropagation();
}, { passive: false });

searchdrawer.addEventListener('touchmove', (e) => {
  e.stopPropagation();
}, { passive: false });
